module.exports = {
      id: "product-category-verven-usage",
      viewBox: "0 0 1792 1792",
      url: __webpack_public_path__ + "assets/sprite-28816f.svg#product-category-verven-usage",
      toString: function () {
        return this.url;
      }
    }